module.exports = import("https://cdn.jsdelivr.net/npm/@supabase/supabase-js/+esm");;